import React, { useMemo, useState } from 'react'
import { BrowserRouter } from 'react-router-dom'

import '@ui/styles/fonts.scss'
import '@ui/styles/site.scss'

import { QueryProvider } from '@app/QueryProvider'
import { Session } from '@app/routing/Session/Session'

import { ImpersonationGate } from '@pages/ImpersonationAuth/ImpersonationGate'

import { AccountContextProvider, initiateAccountContext } from '@context/AccountContextContext'
import { FeatureFlagsProvider } from '@context/FeatureFlagsContext'
import { IBCampaignsResultsContextProvider } from '@context/IBCampaignsResultsContext'
import { MaintenanceModeProvider } from '@context/MaintenanceModeContext'
import { NotificationsContextProvider } from '@context/NotificationsContext'
import { SensitiveDataProvider } from '@context/SensitiveDataContext'

import { ApiClient, ApiClientContext } from '@utils/ApiClient'
import { CategorySizesContextProvider } from '@utils/CategorySizesContext'
import { SharedContext, StateSharedState, initialSharedContext } from '@utils/SharedContext'

import { initiateNotificationsContext } from '@global/notification/notification'

export const App: React.FC = () => {
  const apiClient = useMemo(() => new ApiClient(), [])

  const [sharedState, setSharedState] = useState<StateSharedState>(initialSharedContext)

  return (
    <ImpersonationGate>
      <QueryProvider>
        <BrowserRouter>
          <ApiClientContext.Provider value={apiClient}>
            <AccountContextProvider account={initiateAccountContext()}>
              <SharedContext.Provider value={[sharedState, setSharedState]}>
                <MaintenanceModeProvider>
                  <IBCampaignsResultsContextProvider>
                    <CategorySizesContextProvider>
                      <NotificationsContextProvider
                        initialSettings={initiateNotificationsContext()}
                      >
                        <SensitiveDataProvider>
                          <FeatureFlagsProvider>
                            <Session />
                          </FeatureFlagsProvider>
                        </SensitiveDataProvider>
                      </NotificationsContextProvider>
                    </CategorySizesContextProvider>
                  </IBCampaignsResultsContextProvider>
                </MaintenanceModeProvider>
              </SharedContext.Provider>
            </AccountContextProvider>
          </ApiClientContext.Provider>
        </BrowserRouter>
      </QueryProvider>
    </ImpersonationGate>
  )
}

export default App
